import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromHome from '../../state';
import { Observable, Subject } from 'rxjs';
import { InitialUnreadCountModel } from '../../../shared/data/models/initial-unread-count.model';
import * as fromRoot from '../../../state';
import { SettingsState, State } from '../../../core/settings/settings.model';
import { selectSettings } from '../../../core/settings/settings.selectors';
import { actionSettingsChangeTheme } from '../../../core/settings/settings.actions';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';

import { PostGroupDialogComponent } from '../../group/post-group-dialog/post-group-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Actions, ofType } from '@ngrx/effects';
import { HomeActionTypes } from '../../state/actions/post.action';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'anms-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavComponent implements OnInit {
  currentUser$: Observable<MiniUserModel>;
  settings$: Observable<SettingsState>;
  isAuthenticated$: Observable<boolean>;
  unSubscribed$ = new Subject<boolean>();

  constructor(
    private store$: Store<fromHome.State>,
    private appStore$: Store<State>,
    public dialog: MatDialog,
    private actions$: Actions
  ) {}

  ngOnInit(): void {
    this.currentUser$ = this.store$.select(fromRoot.getMe);
    this.settings$ = this.appStore$.pipe(select(selectSettings));
    this.isAuthenticated$ = this.store$.select(fromRoot.getIsAuthenticated);
  }

  createPost(): void {
    const dialogRef = this.dialog.open(PostGroupDialogComponent, {
      panelClass: 'post-group-dialog-dialog',
      width: '700px',
      height: 'auto',
      data: { type: 'post' }
    });

    this.actions$
      .pipe(
        takeUntil(this.unSubscribed$),
        ofType(HomeActionTypes.CreateNormalPostSuccess)
      )
      .subscribe(_ => dialogRef?.close());
  }

  onThemeSelect(theme) {
    this.appStore$.dispatch(actionSettingsChangeTheme({ theme: theme }));
  }
}
